export const dashboardVariables = {
    PARTNER_DASHBOARD_DEFAULT_ROW: 25
}
export const PARTNER_DASHBOARD_PAGE_SIZES = [15, 25, 50, 100]
export const DEFAULT_ACTIVE_INDEX = 0
export const PARTNER_DASHBOARD_MIN_ROWS = 0